import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { actions, clients } from '../directory/new-visit/visite_data_static'; 
// import * as $ from 'jquery'
import { DashboardService } from '../rest_services/dashboard.service';
import { VisitService } from '../rest_services/visit.service';
import { NewactionService } from '../rest_services/newaction.service';
import { getUniqueId } from '../rest_services/utilFunctions/functions_utiles';
import { CustomersService } from '../rest_services/customers.service';
import { Customer } from '../models/customer';
import { ServiceResponse } from '../models/service-response';
import { Subscription } from 'rxjs';
import {v4 as uuidv4} from 'uuid';
import { MsSectorService } from '../rest_services/ms-sector.service';
import { SettingsService } from '../rest_services/settings.service';
import { ClassService } from '../rest_services/class.service';
import { phoneNumberValidator } from '../validators/phone-number.validator';

// MF-1881 — borne haute du nombre de sujets par visite.
const MAX_TOPICS = 5;

@Component({
  selector: 'app-planifier',
  templateUrl: './planifier.component.html',
  styleUrls: ['./planifier.component.css']
})
export class PlanifierComponent implements OnInit {

  actionsSelected:any[]=[];
  actionsTeam:any[]=actions;
  refClients:any[]=clients;clientsOfSector:any[]=[];
  citiesClient:any[]=[];
  visitsaffected:any[]= [];
  visitcreated:any[]= [];
  customizedActions:any[]=[];
  cities:any[]=[];
  sites:any[]=[];
  sitesOfCity:any[]=[];
  services:any[]=[];
  loadingCustomers:boolean=false;

  customer:any;
  address:any="- - -";
  newActionForm: FormGroup;
  dateForm: FormGroup;
  actionNotAssigned:boolean= false;
  
  htmlYouWantToAdd:any="";
  
  sector:any;
  

  showDiv = {
    previous : false,
    
  }

  // get Customer Commercial
  commercialCustomersSubscription!: Subscription;

  // add customer
  newCustomerForm!: FormGroup;
  refCities:any[]=[];
  role:any=null;
  loadingAddingCustomer: boolean=false;
  newCustomerRequest:any={};
  addError: string="";


  // searchCustomer
  loadingSearchCustomer: boolean=false;
  searchCustomerForm!: FormGroup;
  searchSubscription!: Subscription;
  searchedCustomers!: any[];
  searchLoading: boolean=false;

  classesSubscription!: Subscription;

  reportedVisits:any[]=[];
  canceledVisits:any[]=[];
  affectedVisits:any[]=[];
  affectedVisitsLoader = true;
  canceledVisitsLoader = true;
  reportedVisitsLoader = true;

  constructor(private fb: FormBuilder,private dashboardServiceservice:DashboardService, private settingsService:SettingsService, private msSector : MsSectorService,
    private visitService:VisitService ,private customersService:CustomersService ,private newactionServiceService:NewactionService,
    private classService:ClassService) { 
    this.getAffected(1);
    this.getAffected(4);
    this.getAffected(5);
    this.dateForm = this.fb.group({
      'date':['',Validators.required]
    })
    this.newActionForm = this.fb.group({
      'sector_uuid': [''],
      'city_uuid' : ['', Validators.required],
      'site_uuid' : [''],
      'customer_uuid': ['', Validators.required],
      'action_description': [''],
      'planned_date': ['', Validators.required],
      // MF-1881 — 1 à 5 sujets.
      'topic_uuid': [[] as string[], [Validators.required, Validators.minLength(1), Validators.maxLength(MAX_TOPICS)]],
      'goal':['', [
        Validators.required,
        Validators.maxLength(255)
      ]],
    });
    this.newActionForm.controls['sector_uuid'].setValue("", {onlySelf: true});
    this.newActionForm.controls['customer_uuid'].setValue("", {onlySelf: true});
    this.newActionForm.controls['city_uuid'].setValue("", {onlySelf: true});
    this.loadScript("../assets/js/element/custom-list.js");

   }
   updateSitesForCity(selectedelement:any, cityUuid:any){
    const matchingSites = (selectedelement?.sites || []).filter((s:any) => s.city_uuid == cityUuid);
    this.sitesOfCity = matchingSites;
    if(matchingSites.length == 1){
      this.newActionForm.controls['site_uuid'].setValue(matchingSites[0].uuid, {onlySelf: true});
      this.address = matchingSites[0].address;
    } else {
      this.newActionForm.controls['site_uuid'].setValue("", {onlySelf: true});
      this.address = '- - -';
    }
   }
   invalidDate:boolean=true;
   checkDateValue(){
    const visitFormValue = this.newActionForm.value;
    
    if(visitFormValue.planned_date!=null && visitFormValue.planned_date!=""){
      var currentYear = new Date().getUTCFullYear();
      var dateVisit = new Date(visitFormValue.planned_date);
      var year = dateVisit.getUTCFullYear();
      var month = dateVisit.getUTCMonth() + 1; //months from 1-12
      var day = dateVisit.getUTCDate();
      if(year>currentYear || month > 12 || day>31){
        this.invalidDate = true;
      }else {
        this.invalidDate = false;
      }
    }else{
      this.invalidDate = false;
    }
   }

   // Ajoutez ces propriétés pour gérer l'état de chaque section
  suggestionsCollapsed = true;
  affectedVisitsCollapsed = true;
  reportedVisitsCollapsed = true;
  canceledVisitsCollapsed = true;

  // Méthodes pour toggle chaque section
  toggleSuggestions() {
    this.suggestionsCollapsed = !this.suggestionsCollapsed;
  }

  toggleAffectedVisits() {
    this.affectedVisitsCollapsed = !this.affectedVisitsCollapsed;
  }

  toggleReportedVisits() {
    this.reportedVisitsCollapsed = !this.reportedVisitsCollapsed;
  }

  toggleCanceledVisits() {
    this.canceledVisitsCollapsed = !this.canceledVisitsCollapsed;
  }
  requiredFields: string[] = [];
  token : any = '';
  currentYear = new Date().getUTCFullYear();
   ngOnInit(): void {
    this.getConfig();
    this.getClasses();
    this.token = sessionStorage.getItem("msToken") || localStorage.getItem("msToken");
    if (window.screen.width < 768) { // 768px portrait
      this.mobile = true;
    }else {
      this.mobile = false;
    }
    if(localStorage.getItem("role")!=undefined) {
      this.commercialFullName=localStorage.getItem("fullname");
      this.role =localStorage.getItem("role");
    }else if(sessionStorage.getItem("role")!=undefined){
      this.role =sessionStorage.getItem("role");
      this.commercialFullName=sessionStorage.getItem("fullname");
    }
    // get Commercial Customer
    this.getAllCustomers();
    $('#actionsToSelect').change(function(){ 
      var value = $(this).val();
      var uuid = $("option:selected", this).attr("ud");
      var elt = glob.customizedActions.find(el => el.action_uuid == value);
      var action = {
        action_description : $( "#actionsToSelect option:selected" ).text(),
        action_type : "c",
        action_uuid : uuid
      }
      let index = glob.actionsSelected.findIndex(d => d.action_description == elt.action_label);      
      if(index<0){
        glob.actionsSelected.push(action);
        setTimeout(()=>{
          $('#actionsToSelect').val("")
        }, 500);
      }
      if(glob.actionsSelected.length>0){
        glob.actionNotAssigned = false;
      }else {
        // if($('#datePlanned').val() != "" && $('#datePlanned').val() != null){
          glob.actionNotAssigned = true;
          $("#noActionsSelected").css({"color":"red"});
        // }else {
        //   glob.actionNotAssigned = false;
        // }
      }
    });
    var curr = new Date; // get current date
    var first = curr.getDate() - curr.getDay()+1; // First day is the day of the month - the day of the week
    var last = first + 6; // last day is the first day + 6

    this.firstDayOfWeek = new Date(curr.setDate(first));
    var glob = this;
    // $("#clientSelect").prop("disabled", true);
    $("#citiesSelect").prop("disabled", true);
    var blocActions = this.htmlYouWantToAdd;
    $('#sectorsSelect').change(function(){ 
      var value = $(this).val();
      glob.address = "- - -";
      glob.loadingCustomers =true;
      $("#citiesSelect").prop("disabled", true);
      if(value){
        glob.getCustomers(value);
      } else{
        glob.getAllCustomers();
      }
      glob.newActionForm.controls['customer_uuid'].setValue("", {onlySelf: true});

      
    });
    
    // $('#datePlanned').change(function(){ 
    //   var value = $(this).val();
    //   if(value=="" || value==null){
    //     if(glob.actionsSelected.length>0){
    //       glob.actionNotAssigned = false;
    //     }else {
    //       glob.actionNotAssigned = true;
    //     }
    //   }else {
    //     if(glob.actionsSelected.length==0){
    //       $("#noActionsSelected").css({"color":"red"});
    //       glob.actionNotAssigned = true;
    //     }
    //   }
    // });
    // $("#citiesSelect").prop("disabled", true);
    var glob = this;
    var blocActions = this.htmlYouWantToAdd;
    $(document).ready(function() {
      $('#citiesSelected').change(function() {
        var value = $(this).val();
        var elt = glob.cities.find((el:any) => el.uuid == value);
        var uuid = $("option:selected", this).attr("ud");
        var city = {
          name: $( "#citiesSelected option:selected" ).text(),
          sites: [],
          uuid: uuid
        };
        let index = -1;
        if (elt !== undefined) {
          index = glob.cities.findIndex((d :any) => d.name == elt.city);
        }
        if (index < 0 && value !== "") {
          var alreadySelected = glob.cities.some((item: any) => item.uuid === uuid);
          if (!alreadySelected) {
            const existingCity = glob.cities.find((item: any) =>
              glob.compareStringsIgnoringAccents(item.name.toString(), city.name.toString())
            );
            if (!existingCity) {
              glob.cities.push(city);
              glob.cityAdded = glob.cities.length > 0;
              setTimeout(function() {
                $('#citiesSelected').val("");
              }, 500);
            }
          } else {
            $("html, body").animate({scrollTop:0});
            glob.addError = "La ville que vous avez sélectionné existe déjà pour ce compte client !";
            $("#customer_not_added").show();
            $("#customer_not_added").css("z-index", "9999");
            $("#customer_not_added").css("right", "34%");
            $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            });
            setTimeout(()=>{
              // $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // });
              $("#customer_not_added").hide();
            }, 8000);
          }
        }         
        // Update the 'city' form control's required attribute based on the cities array
        const cityFormControl = $('#citiesSelected')[0] as HTMLSelectElement;
        cityFormControl.required = glob.cities.length === 0;

        // Update the validity of the 'city' form control
        cityFormControl.setCustomValidity(cityFormControl.validity.valid ? '' : 'Please select a city.');
      });

      // Get references to the file input and imageDiv elements
    const logoInput = document.getElementById('logoInput') as HTMLInputElement;
    const imageDiv = document.getElementById('imageDiv');

    // Add an event listener to the file input
    logoInput.addEventListener('change', (event) => {
        const selectedFile = logoInput.files?.[0]; // Use the logoInput reference

        // Check if a file was selected
        if (selectedFile) {
            // Read the selected file as a data URL
            const reader = new FileReader();
            reader.onload = (e) => {
              const logoDataUrl = e.target?.result as string; // Use optional chaining
              // Create an <img> element and set its src attribute
              const imgElement = document.createElement('img');
              imgElement.src = logoDataUrl;
              imgElement.style.margin='0 30%';
              imgElement.style.width = '70px';
              imgElement.style.height = '70px';
              imgElement.style.borderRadius= "50%";
              imgElement.style.border = 'solid 5px #bad0c9'; // Add a border
              if(imageDiv){
                // Clear any existing content in the imageDiv and append the image
              imageDiv.innerHTML = '';
              imageDiv.appendChild(imgElement);
              }
            };
            reader.readAsDataURL(selectedFile);
        } else {
            // Clear the imageDiv if no file is selected
            if (imageDiv)imageDiv.innerHTML = '';
        }
    });
    });
    $('#clientSelect').change(function(){
      $("#citiesSelect").prop("disabled", false);
      // glob.newActionForm.controls['sector_uuid'].enable();
      var value = $(this).val();      
      if(value==null || value==""){
        glob.newActionForm.controls['city_uuid'].setValue("", {onlySelf: true});
      }
      glob.newActionForm.controls['city_uuid'].setValue("", {onlySelf: true});

      var city=null;
      glob.address = "- - -";
      var cities = [];
      var selectedelement = glob.refClients.find(d => d.uuid== value);   
      if (selectedelement && selectedelement.cities && selectedelement.cities.length > 0) {
        for (const item of selectedelement.cities) {
          city = {
            city: item.name,
            city_uuid: item.uuid,
            agent: item.contact,
            address: null,
            customer: selectedelement.uuid
          }
          cities.push(city);
        }
      }    
      if(cities.length>0){
        $("#citiesSelect").prop("disabled", false);
        glob.citiesClient = cities;
      }else {
        $("#citiesSelect").prop("disabled", true);
      }

      glob.sitesOfCity = [];
      glob.newActionForm.controls['site_uuid'].setValue("", {onlySelf: true});
      glob.newActionForm.controls['sector_uuid'].setValue(selectedelement.sector);
      if(selectedelement.cities.length==1){
        glob.newActionForm.controls['city_uuid'].setValue(selectedelement.cities[0].uuid);
        glob.updateSitesForCity(selectedelement, selectedelement.cities[0].uuid);
      }
    });

    $('#citiesSelect').change(function(){
      var value = $(this).val();
      var elements = glob.citiesClient.find(d => d.city_uuid== value);
      var selectedelement = glob.refClients.find(d => d.uuid== elements?.customer);
      glob.customer = elements?.customer;
      glob.updateSitesForCity(selectedelement, value);
    });

    $(document).on('change', '#siteSelect', function(){
      var value = $(this).val();
      var selectedSite = glob.sitesOfCity.find((s:any) => s.uuid == value);
      glob.address = selectedSite?.address ?? '- - -';
    });
    $('#customer_cities').change(function() {
      var value = $(this).val();
      var cityName = $(this).find("option:selected").text();
    
      // Check if the city name already exists in the glob.cities array
      var existingCity = glob.cities.find((city) => city.name === cityName);
    
      // If the city name exists, update its UUID
      if (existingCity) {
        existingCity.uuid = value;
      } else {
        // If the city name doesn't exist, add a new city to the glob.cities array
        var city = {
          name: cityName,
          uuid: value
        };
        glob.cities.push(city);
    
        setTimeout(function() {
          $('#customer_cities').val("");
        }, 500);
      }
    
      // Update the 'city' form control's required attribute based on the cities array
      const cityFormControl = $('#customer_cities')[0] as HTMLSelectElement;
      cityFormControl.required = glob.cities.length === 0;
    
      // Update the validity of the 'city' form control
      cityFormControl.setCustomValidity(cityFormControl.validity.valid ? '' : 'Please select a city.');
    });
    this.getClassesIndicatorsOfCommercialCustomers();
    this.getSectors();
    this.getTopics();
    this.getPublicActions();
    this.getAllCustomizedActions();
    // this.getIndicatorsClassesCustomers();
    // this.getCustomers(this.sector);
    this.loadCss("../assets/css/design.css");

     //add new customer
     this.newCustomerForm = this.fb.group({
      'social': ['', Validators.required],
      'sector' : ['', Validators.required],
      'agent' : [''],
      'email' : ['', [Validators.email]],
      'city' : [''],
      'zip' : [''],
      'address' : [''],
      'phone' : ['', [phoneNumberValidator()]],
      'skype' : [''],
      'class' : [''],
      'city_label':[''],
      'selectedCity':[''],
      'extraSite':[''],
      'selectedSite':[''],
      'service': [''],
      'cmrc':[this.commercialFullName],
      'logo':['']
    });

    this.newCustomerForm.valueChanges.subscribe(() => {
      this.requiredFields = [];

      const socialControl = this.newCustomerForm.get('social');
      if (socialControl && socialControl.invalid) {
        this.requiredFields.push('social');
      }
    
      const sectorControl = this.newCustomerForm.get('sector');
      if (sectorControl && sectorControl.invalid) {
        this.requiredFields.push('sector');
      }
    
      //const cityControl = this.newCustomerForm.get('city');
      if (this.cities.length==0) {
        this.requiredFields.push('city');
      }
    });

    // search Customer
    this.searchCustomerForm = this.fb.group({
      'social':[''],
      'sector':[''],
      'city':[''],
      'classe' : ['']
    })

    this.getCities();
  }
  classes:any[]=[];
  getClasses(){
    this.classesSubscription = this.classService.getClasses().subscribe(
      (data: ServiceResponse) => {        
        if(data.code == "7cd8d69b7048301e37f4ddaf4959218c"){
          this.classes = data.classes?data.classes:[];
        }    
      },
      (error: any) => {
        console.log(error);
      }
    );
  }
  config: any = {
    skypeVisibility: false,
    zipCodeVisibility: false
  };
  getConfig(){
    this.settingsService.getConfig().subscribe(
      (resp: any) => {
        if(resp.code == "45859d1ba9e878f62c51935e3119d7ad"){
          this.config.skypeVisibility = resp.config.skypeVisibility;
          this.config.zipCodeVisibility = resp.config.zipCodeVisibility;
        }
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  commercialFullName:any;
  
  selectedLogo: File | null = null;
  onLogoSelect(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files && inputElement.files.length > 0) {
      this.selectedLogo = inputElement.files[0];
    }
  }


  cityAdded:any =false;
  //add a new city
  newCity() {
   const cityFormValue = this.newCustomerForm?.get('city_label')?.value;
   if (cityFormValue) {
     const existingCity = this.cities.find((city: any) =>
       this.compareStringsIgnoringAccents(city.name.toString(), cityFormValue.toString())
     );
     const existingRefCity = this.refCities.find((city: any) =>
       this.compareStringsIgnoringAccents(city.city.toString(),cityFormValue.toString())
     );
     if (existingRefCity != undefined) {
       $("html, body").animate({scrollTop:0});
       this.addError = "La ville existe déjà. Veuillez la sélectionner dans la liste déroulante !";
       $("#customer_not_added").show();
         // Increase the z-index of the alert to make it appear above the popup
         $("#customer_not_added").css("z-index", "9999");
         $("#customer_not_added").css("right", "34%");
       $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
       });
       setTimeout(()=>{
         // $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
         // });
         $("#customer_not_added").hide();
       }, 8000);
     }else if (existingCity !=undefined) {
      $("html, body").animate({scrollTop:0});
          this.addError = "La ville que vous avez saisi existe déjà pour ce compte client !";
          $("#customer_not_added").show();
          $("#customer_not_added").css("z-index", "9999");
          $("#customer_not_added").css("right", "34%");
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            // $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // });
            $("#customer_not_added").hide();
          }, 8000);
      //this.cityAdded = this.customer_cities.length > 0;
    } else if (!existingCity) {
       const capitalizedCity = cityFormValue.charAt(0).toUpperCase() + cityFormValue.slice(1).toLowerCase();
       const newCity = {
         name: capitalizedCity,
         uuid: uuidv4(),
         sites: []
       };
       this.cities.push(newCity);
       this.cityAdded = this.cities.length > 0;
     }
   }
  } 
  removeCity(city: any) {
    const cityIndex = this.cities.findIndex((c: any) => c.uuid === city.uuid);
    if (cityIndex !== -1) {
      const cityToRemove = this.cities.splice(cityIndex, 1)[0];
  
      //  // Remove all sites associated with the deleted city
      //  const siteIndicesToDelete = this.sites
      //    .filter((site: any) => site.city_uuid === cityToRemove.uuid)
      //    .map((site: any) => this.sites.indexOf(site))
      //    .sort((a, b) => b - a); // Sort in reverse order to avoid index issues
  
      //  siteIndicesToDelete.forEach((siteIndex) => {
      //    const deletedSite = this.sites.splice(siteIndex, 1)[0];
  
      //    // Remove all services associated with the deleted site
      //    const serviceIndicesToDelete = this.services
      //      .filter((service: any) => service.site_uuid === deletedSite.site_uuid)
      //      .map((service: any) => this.services.indexOf(service))
      //      .sort((a, b) => b - a); // Sort in reverse order to avoid index issues
  
      //    serviceIndicesToDelete.forEach((serviceIndex) => {
      //      this.services.splice(serviceIndex, 1);
      //    });
      //  });
      this.cityAdded = this.cities.length > 0;
    }
  }
  // removeCity(city: any) {
  //   const cityIndex = this.cities.findIndex((c: any) => c.uuid === city.uuid);
  //   if (cityIndex !== -1) {
  //     const cityToRemove = this.cities.splice(cityIndex, 1)[0];
  //   }
  // }
  newSite() {
    const selectedCityId = this.newCustomerForm?.get('selectedCity')?.value;
    const siteFormValue = this.newCustomerForm?.get('extraSite')?.value;
    const addressFormValue = this.newCustomerForm?.get('address')?.value;

    if (selectedCityId && siteFormValue) {
      const selectedCity = this.cities.find((city: any) => city.uuid === selectedCityId);
      if (selectedCity) {
        const existingSite = this.sites.find((site: any) => site.site_name === siteFormValue && site.city_uuid === selectedCityId);
        if (!existingSite) {
          const newSite = {
            site_name: siteFormValue,
            site_uuid: uuidv4(),
            city_uuid: selectedCityId,
            site_address: addressFormValue, // Add address to newSite
            services: []
          };
          this.sites.push(newSite);
          selectedCity.sites.push(newSite);
          this.newCustomerForm?.get('extraSite')?.setValue('');
          this.newCustomerForm?.get('address')?.setValue('');
          $("#selectedCities").val("");
          // this.siteAdded = this.sites.length > 0;
        }
      }
    }
  }
  removeSite(site: any, city: any) {
    const siteIndex = this.sites.findIndex((s: any) => s.site_uuid === site.site_uuid);
    if (siteIndex !== -1) {
      this.sites.splice(siteIndex, 1);
      const cityIndex = city.sites.findIndex((s: any) => s.site_uuid === site.site_uuid);
      if (cityIndex !== -1) {
        city.sites.splice(cityIndex, 1);
        // Remove the related services for the deleted site
        const relatedServices = site.services;
        for (const service of relatedServices) {
          const serviceIndex = site.services.findIndex((s: any) => s.service_uuid === service.service_uuid);
          if (serviceIndex !== -1) {
            site.services.splice(serviceIndex, 1);
          }
          const servicesIndex = this.services.findIndex((s: any) => s.service_uuid === service.service_uuid);
          if (servicesIndex !== -1) {
            this.services.splice(servicesIndex, 1);
          }
        }
      }
    }
  }
  // Function to add a new service to a site
  addService() {
    const selectedSiteId = this.newCustomerForm?.get('selectedSite')?.value;
    const serviceName = this.newCustomerForm?.get('service')?.value;

    if (selectedSiteId && serviceName) {
      const selectedSite = this.sites.find((site: any) => site.site_uuid === selectedSiteId);
      if (selectedSite) {
        const existingService = selectedSite.services.find((service: any) => service.service_name === serviceName);
        if (!existingService) {
          const newService = {
            service_name: serviceName,
            service_uuid: uuidv4(),
            site_uuid:selectedSiteId
          };
          selectedSite.services.push(newService);
          this.services.push(newService);
          this.newCustomerForm?.get('service')?.setValue('');
          $("#selectedSites").val("");
        }
      }
    }    
  }
  getCityName(cityUuid: string): string {
    const city = this.cities.find((c: any) => c.uuid === cityUuid);
    return city ? city.name : 'Unknown City'; // Replace 'Unknown City' with your desired default value.
  }
  // Function to remove a service from a site
  removeService(service: any, site: any) {
    const serviceIndex = site.services.findIndex((s: any) => s.service_uuid === service.service_uuid);
    if (serviceIndex !== -1) {
      // Remove the service from the site's services array
      site.services.splice(serviceIndex, 1);

      // Update the services array to remove the service
      const globalServiceIndex = this.services.findIndex((s: any) => s.service_uuid === service.service_uuid);
      if (globalServiceIndex !== -1) {
        this.services.splice(globalServiceIndex, 1);
      }
    }
  }
  compareStringsIgnoringAccents(str1: string, str2: string): boolean {
    if (!str1 || !str2) {return false;}
    const normalizedStr1 = str1.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    const normalizedStr2 = str2.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return normalizedStr1.toLowerCase() === normalizedStr2.toLowerCase();
  }

   visit:any;
   visite:any;
   createdvisit:any;
   finalOldVisitToPlanify:any[]=[];
   existVisitForGoal:boolean=false;
  //  affected:any[]=[];
   addtoaffected(visit:any, status:number) {
     let index;
     let affected=[];
     this.ShowBlocNewVisit = false;
     switch (status) {
      case 1:
        affected = this.affectedVisits;
        break;
      case 4:
        affected = this.canceledVisits;
        break;
      case 5:
        affected = this.reportedVisits;
        break;
     
      default:
        break;
     }
     index = affected.findIndex((d:any) => d.visit=== visit.visit);
     this.visite = visit;
     this.visite.planned_at=this.visite.planned_At ?? null;
     this.visite.statusMotif=status;
     this.visite.visit_uuid=visit.visit;
     this.visite.actions = [];

     // MF-1881 — pré-remplit la ligne avec les sujets déjà définis sur la visite, typiquement
     // par le directeur commercial depuis l'écran des objectifs de CA. Sans cela, la liste
     // déroulante s'ouvrait vide et le commercial devait les ressaisir — ou les perdait, puisque
     // la requête aurait envoyé une liste vide.
     //
     // topic_uuids porte les identifiants, topic les libellés, dans le même ordre (voir
     // AffectedVisitEnv côté back). On reconstruit les badges à partir des deux.
     this.prefillRowTopics(this.visite);

     this.finalOldVisitToPlanify.push(this.visite);
    //  this.createdvisit = this.visitsaffected;
     this.createdvisit = this.visite.visit;
     var old = {
      actions : [],
      visit_uuid : this.createdvisit,
      visit : this.createdvisit,
      planned_at : null
    }
    
    //  this.visitsaffected.push(old);
     $("#formNewVisit").hide();
    $("#blocListCreatedVisits").show();
    switch (status) {
      case 1:
        this.affectedVisits.splice(index, 1);
        break;
      case 4:
        this.canceledVisits.splice(index, 1);
        break;
      case 5:
        this.reportedVisits.splice(index, 1);
        break;
     
      default:
        break;
     }
   }
   add(plan:any){
    const ActionFormValue = this.newActionForm.value;
      this.plan = {
        actions :ActionFormValue.action_description,
        customer_rs :$("#clientSelect option:selected").text()
      };
    this.visite = this.plan;
    this.visitcreated.push(this.visite);
    this.newActionForm.reset();
    this.actionsSelected = [];
   }
   finalVisitsToAffect:any[]=[];
   togenerateUuid:number = 10;
   indexInitWizard:number = 2;
   indexListInitWizard:number = 1;
   addnewvisit(){
    this.checkDateValue()
    if(!this.invalidDate){
      const formvalues = this.newActionForm.value;    
      var uuid = getUniqueId(this.togenerateUuid);    
       var visit = {
        sector_uuid: formvalues.sector_uuid,
        customer_uuid:formvalues.customer_uuid,
        city_uuid:(<HTMLSelectElement>document.getElementById('citiesSelect')).value,
        site_uuid:formvalues.site_uuid,
        customer_rs :$("#clientSelect option:selected").text(),
        planned_date:formvalues.planned_date,
        goal:formvalues.goal,
        // MF-1881 — le back attend une liste nommée topics.
        topics: this.selectedTopicUuids(),
        actions :this.actionsSelected,
        visit : uuid,
        index: this.selectedIndex
      }        
      var plan = {
        // MF-1881 — la ligne d'origine lisait le LIBELLÉ affiché dans le DOM via jQuery
        // ($("#selectTopic option:selected").text()), et non l'identifiant du formulaire.
        // Avec une sélection multiple, .text() renverrait les libellés collés les uns aux
        // autres. La valeur vient maintenant du formulaire, comme les autres champs.
        topics : this.selectedTopicUuids(),
        topics_labels : this.selectedTopicLabels(),
        actions :this.actionsSelected,
        customer_rs :$("#clientSelect option:selected").text(),
        customer_city :$("#citiesSelect option:selected").text(),
        customer_site :$("#siteSelect option:selected").text(),
        planned_date:formvalues.planned_date,
        visit: uuid
      };
      this.togenerateUuid = this.togenerateUuid +10;
      // this.visitcreated.push(plan);
      this.visitsaffected.push(plan)
      this.finalVisitsToAffect.push(visit);
      this.ShowBlocNewVisit=false; 
      
      this.newActionForm.reset();
      this.newActionForm.controls['sector_uuid'].setValue("", {onlySelf: true});
      this.newActionForm.controls['customer_uuid'].setValue("", {onlySelf: true});
      this.newActionForm.controls['city_uuid'].setValue("", {onlySelf: true});
      this.newActionForm.controls['site_uuid'].setValue("", {onlySelf: true});
      this.newActionForm.controls['topic_uuid'].setValue([], {onlySelf: true});
    this.resetSelectedTopics(); // MF-1881 — vide aussi les badges
      this.sitesOfCity = [];
      this.address = "- - -";
      this.actionsSelected = [];
      
      this.getAllCustomers();
      if(this.indexListInitWizard<this.selectedSuggestions.length){
        if(this.selectedSuggestions.length>1){
          this.select(this.selectedSuggestions[this.indexListInitWizard].customer,this.selectedSuggestions[this.indexListInitWizard],this.selectedIndexes[this.indexListInitWizard]);
          this.indexInitWizard = this.indexInitWizard+1;
          this.indexListInitWizard = this.indexListInitWizard+1;
        }else {
          $("#formNewVisit").hide();
          $("#blocListCreatedVisits").show();
          this.selectedSuggestions =[];
          this.selectedIndexes=[];
        }
        
        // if(this.indexListInitWizard==this.selectedSuggestions.length){
          
        // }
      }else if(this.indexListInitWizard==this.selectedSuggestions.length){
        $("#formNewVisit").hide();
        $("#blocListCreatedVisits").show();
        this.selectedSuggestions =[];
        this.selectedIndexes=[];
      }else {
        $("#formNewVisit").hide();
        $("#blocListCreatedVisits").show();
        this.selectedIndex = "";
        this.selectedSuggestions =[];
        this.selectedIndexes=[];
      }
    }
   }
   Delete(uuidVisit:any, status:number){
     let index;
     var toDelete = this.visitsaffected.find(obj => obj.visit === uuidVisit);
     index = this.visitsaffected.findIndex((d:any) => d===toDelete);
     
     if(index>=0){
      // let visit_to_delete = this.visitsaffected.find((d:any) => d.visit);
      switch (status) {
       case 1:
         this.affectedVisits.push(toDelete);
         break;
       case 4:
         this.canceledVisits.push(toDelete);
         break;
       case 5:
         this.reportedVisits.push(toDelete);
         break;
      
       default:
         break;
      }
      // affected.push(toDelete)
      this.visitsaffected.splice(index, 1)
      var indexold = this.finalOldVisitToPlanify.findIndex((d:any) => uuidVisit);
      if(this.finalOldVisitToPlanify.length>0 && indexold>0){
        this.finalOldVisitToPlanify.splice(indexold, 1);
      }else {
        var indexnew = this.finalVisitsToAffect.findIndex((d:any) => uuidVisit);
        this.finalVisitsToAffect.splice(indexnew, 1)
      }
      
     }
     

   }
   supaffected(){
     let index;
     index = this.visitsaffected.findIndex((d:any) => d.visit);
     let visit_to_delete = this.visitsaffected.find((d:any) => d.visit);
     switch (this.status) {
      case 1:
        this.affectedVisits.push(visit_to_delete);
        break;
      case 4:
        this.canceledVisits.push(visit_to_delete);
        break;
      case 5:
        this.reportedVisits.push(visit_to_delete);
        break;
     
      default:
        break;
     }
     this.visitsaffected.splice(index, 1)

    //  created_visit : this.finalOldVisitToPlanify,
    //         new_visits : this.finalVisitsToAffect
   }
   plannedat:any;
   dateaffected(event:any,uuidVisit:any){
    this.plannedat = event;
    var myVisit = this.finalVisitsToAffect.find(obj => obj.visit === uuidVisit);
    if(myVisit != null){
      let index = this.finalVisitsToAffect.indexOf(myVisit);
      myVisit.planned_at=this.plannedat;
      myVisit.planned_date=this.plannedat;
      this.finalVisitsToAffect[index] = myVisit;
      this.finalVisitsToAffect[index].planned_at = this.plannedat;
    }
    var oldAffected = this.finalOldVisitToPlanify.find(obj => obj.visit === uuidVisit);
    if(oldAffected != null){
      let indexOldAffected = this.finalOldVisitToPlanify.indexOf(oldAffected);
      this.finalOldVisitToPlanify[indexOldAffected].planned_at = this.plannedat;
    }
   }
  firstDayOfWeek:Date =new Date();
  mobile:boolean=false;

  status!:number;
  getStatus(status:number){
    this.status=status;
  }


  planifier:any;
  getAffected(status:number){
    this.dashboardServiceservice.getAffected(status).subscribe(
      ( data: any ) => {        
        if(data.code =="7f970252917c98638f9235a0f80b2bcd"){
          switch (status) { 
           case 1:
              this.affectedVisits = data.visits;
              // MF-1881 — une visite à prioriser est une visite SANS AUCUN sujet.
              // Le test « === null » ne fonctionne plus : en JavaScript un tableau vide
              // n'est ni null ni falsy, le badge disparaîtrait pour toutes les visites.
              const visitsWithNulls = this.affectedVisits.filter(visit =>
                  this.hasNoTopic(visit) && visit.motif === null
              );
              this.existVisitForGoal = visitsWithNulls.length > 0;
             break;
           case 4:
             this.canceledVisits = data.visits;
             break;
           case 5:
             this.reportedVisits = data.visits;
             break;
          
           default:
             break;
          } 
        }

        switch (status) { 
          case 1:
            this.affectedVisitsLoader = false;
            break;
          case 4:
            this.canceledVisitsLoader = false;
            break;
          case 5:
            this.reportedVisitsLoader = false;
            break;
         
          default:
            break;
         }
        
      },
      (err:any) =>{
        console.log(err);
        switch (status) { 
          case 1:
            this.affectedVisitsLoader = false;
            break;
          case 4:
            this.canceledVisitsLoader = false;
            break;
          case 5:
            this.reportedVisitsLoader = false;
            break;
         
          default:
            break;
         }
      }
    )  
  }
  plan:any;
  planedRequest:any;
  refSectors:any[]=[];
  getSectors(){
    this.msSector.getSectors(this.token);
    this.msSector.sectorsSubject.subscribe(
      ( data: any ) => {
        if(data.status=="200 OK"){
          this.refSectors = data.sectors;
        }
      },
    )    
  }
  publicActions:any[]=[];
  getPublicActions(){
    this.visitService.getPublicActions();
    this.visitService.actionsSubject.subscribe(
      ( data: any ) => {
        if(data.code=="fc2057117571f77a7b4fdde71772ebcd"){
          this.publicActions = data.actions;
          this.publicActions = this.publicActions.sort((a:any, b:any) => a.action_label.toLowerCase() > b.action_label.toLowerCase() ? 1 : -1);
        }
      },
    )  
  }
  getCustomers(sector:any){
    this.visitService.getCustomersSector(sector);
    this.visitService.customersSubject.subscribe(
      ( data: any ) => {        
        if(data.code=="a899d2fac857262bd6a142d04b59f355"){
          this.clientsOfSector = data.customers;
          this.refClients = data.customers;
          if(data.customers.length>0){
            $("#clientSelect").prop("disabled", false);
          }else {
            $("#clientSelect").prop("disabled", true);
          }
          this.loadingCustomers =false;
          $("#citiesSelect").prop("disabled", true);
        }else {
          this.loadingCustomers =false;
          $("#clientSelect").prop("disabled", true);
        }
      },
    )  
  }
  getAllCustomers(){
    this.commercialCustomersSubscription = this.customersService.getCommercialCustomers().subscribe(
      ( data: ServiceResponse ) => {
        if(data.code=="3c4a33cadc99d89177c0f7e18a2b1bd4"){
          let customerList = data.customers.sort((a:any, b:any) => a.customer_rs.toLowerCase() > b.customer_rs.toLowerCase() ? 1 : -1);
          var newArrayAllCustomers:any[] = [];
          for(let cust of customerList){
            var customer = {
              rs_customer:cust.customer_rs,
              cities:cust.customer_cities,
              uuid:cust.customer,
              address:cust.customer_address,
              sites:cust.sites,
              sector:cust.sector
            }
            newArrayAllCustomers.push(customer);
          }
          this.loadingCustomers = false;      
          setTimeout(()=>{
            this.refClients = newArrayAllCustomers;
            this.clientsOfSector = newArrayAllCustomers;
          }, 1000);
        }
        this.loadingCustomers = false;      
      },
      (err: any)=>{
        this.loadingCustomers = false;      
        console.log(err);
        
      }
    )  
  }
  topics:any;

  // ------------------------------------------------------------------------------------------
  // MF-1881 — sélection multiple des sujets (1 à 5).
  // ------------------------------------------------------------------------------------------

  readonly maxTopics = MAX_TOPICS;

  /**
   * MF-1881 — les sujets choisis, sur le même principe que `actionsSelected`.
   *
   * La saisie reprend le motif déjà en place pour les actions : une liste déroulante SIMPLE,
   * et chaque sujet choisi s'ajoute en badge sous le champ, retirable par sa croix. Pas de
   * `<select multiple>` : il obligerait l'utilisateur à maintenir Ctrl, ne montrerait pas ce
   * qui est choisi une fois la liste refermée, et jurerait avec le reste du formulaire.
   *
   * Chaque élément a la forme { uuid, topic }, comme les entrées du référentiel.
   */
  topicsSelected: any[] = [];

  /** Les identifiants choisis, dans l'ordre d'ajout. */
  selectedTopicUuids(): string[] {
    return this.topicsSelected.map(t => t.uuid).filter((v: any) => !!v);
  }

  /** Les libellés correspondants, pour l'affichage local de la ligne planifiée. */
  selectedTopicLabels(): string[] {
    return this.topicsSelected.map(t => t.topic).filter((v: any) => !!v);
  }

  selectedTopicsCount(): number {
    return this.topicsSelected.length;
  }

  /** Vrai quand la borne haute est atteinte : la liste déroulante se grise alors entièrement. */
  topicsLimitReached(): boolean {
    return this.topicsSelected.length >= MAX_TOPICS;
  }

  /**
   * MF-1881 — ajout d'un sujet depuis la liste déroulante, en badge sous le champ.
   *
   * Même comportement que le gestionnaire des actions : un sujet déjà choisi n'est pas ajouté
   * deux fois, et la liste se remet sur son option vide après l'ajout pour qu'on puisse
   * enchaîner les sélections.
   */
  addSelectedTopic(event: any): void {
    const select = event.target as HTMLSelectElement;
    const uuid = select.value;
    if (!uuid) { return; }

    if (this.topicsSelected.length >= MAX_TOPICS) {
      select.value = "";
      return;
    }

    const already = this.topicsSelected.findIndex(t => t.uuid === uuid) >= 0;
    if (!already) {
      const ref = (this.topics || []).find((t: any) => t.uuid === uuid);
      if (ref) {
        this.topicsSelected.push({ uuid: ref.uuid, topic: ref.topic });
        this.syncTopicControl();
      }
    }
    select.value = "";
  }

  /** MF-1881 — retrait d'un sujet par la croix de son badge. */
  removeSelectedTopic(topic: any): void {
    const index = this.topicsSelected.findIndex(t => t.uuid === topic.uuid);
    if (index >= 0) {
      this.topicsSelected.splice(index, 1);
      this.syncTopicControl();
    }
  }

  /** MF-1881 — vide la sélection, appelé partout où le formulaire est réinitialisé. */
  resetSelectedTopics(): void {
    this.topicsSelected = [];
    this.syncTopicControl();
  }

  /**
   * MF-1881 — recopie la sélection dans le contrôle `topic_uuid`.
   *
   * Le contrôle n'est plus lié à un champ du gabarit, mais il reste dans le formulaire : c'est
   * lui qui porte `Validators.required`, donc ce qui rend `newActionForm.valid` faux tant
   * qu'aucun sujet n'est choisi. Angular considère un tableau vide comme une valeur manquante,
   * le bouton « Enregistrer » reste donc désactivé sans test supplémentaire.
   */
  private syncTopicControl(): void {
    // MF-1881 — SURTOUT PAS onlySelf:true ici. Avec onlySelf, seul le contrôle est
    // réévalué et le FormGroup garde son état précédent : le formulaire restait
    // définitivement invalide, donc le bouton d'enregistrement désactivé même avec des
    // sujets choisis. Sans l'option, la validité remonte au parent.
    this.newActionForm.controls['topic_uuid'].setValue(this.selectedTopicUuids());
    this.newActionForm.controls['topic_uuid'].markAsTouched();
    this.newActionForm.updateValueAndValidity();
  }

  /**
   * MF-1881 — vrai quand la visite ne porte AUCUN sujet.
   *
   * Centralise le test du badge « Visite à prioriser » et des *ngIf du gabarit, qui testaient
   * « visit.topic == null ». Un tableau vide n'est ni null ni falsy en JavaScript : sans cette
   * méthode, chaque test oublié ferait disparaître le badge pour toutes les visites.
   * C'est le critère d'acceptation 8.
   */
  hasNoTopic(visit: any): boolean {
    const topics = visit?.topics ?? visit?.topic;
    if (!topics) { return true; }
    if (Array.isArray(topics)) { return topics.length === 0; }
    return String(topics).trim() === '';
  }

  getTopics(){
    this.visitService.getTopic();
    this.visitService.topicSubject.subscribe(
      ( data: any ) => {
        if(data.code=="d9cc2e7dc2cf71242be86ab1ad241752"){
          this.topics = data.topics;
        }
      },
    )  
  }
  // newVisitBloc(){
  //   var glob = this;
  //   $("#clientSelect").prop("disabled", true);
  //   $("#citiesSelect").prop("disabled", true);
  //   setTimeout(()=>{
  //   kjljm
  //   }, 500);
  //  } 
   action:any;
   newAction(){
    const ActionFormValue = this.newActionForm.value;
    if(ActionFormValue.action_description != null && ActionFormValue.action_description !=""
      && ActionFormValue.action_description !=" "){
        let index = this.actionsSelected.findIndex(d => d.action_description == ActionFormValue.action_description);      
        if(index<0){
          this.action = {
            action_description :ActionFormValue.action_description,
          };
          this.actionsSelected.push(this.action);
          this.actionNotAssigned=false;
        }
      // var customized = {
      //   action_label :ActionFormValue.action_description,
      //   state:"new"
      // }
      // this.customizedActions.push(customized);
      // // this.action = {};
      // $(".customizedActions").animate({ scrollBottom: $(".customizedActions") }, 500);
    }
  }
  removeSelectedAction(list:any[],value:any){
    let index;
    if(value==undefined){
      index = list.findIndex(d => d=== value); //find index in your array
      list=this.actionsSelected;
    }else {
      index = list.findIndex(d => d.action=== value); //find index in your array
      list=this.publicActions;
    }
    this.actionsSelected.splice(index, 1);//remove element from array
    
    if(this.actionsSelected.length>0){
      this.actionNotAssigned = false;
    }else {
      // if($('#datePlanned').val() != "" && $('#datePlanned').val() != null){
        setTimeout(()=>{
          $("#noActionsSelected").css({"color":"red"});
        }, 800);
        this.actionNotAssigned = true;
      // }else {
      //   this.actionNotAssigned = false;
      // }
    }
  }
  affectCustomizeAction(action:any){
    action = {
      action_description :action.action_label,
      action_uuid:action.action_uuid
    };
    this.actionsSelected.push(action)
  }
  newVisitRequest:any;
  loadingPlanifyVisits:boolean=false;
  created_visit: any[]=[];
  Planned() {
    const visitsWithoutDate = this.finalVisitsToAffect.filter(visit => !visit.planned_date);
    const oldVisitsWithoutDate = this.finalOldVisitToPlanify.filter(visit => !visit.planned_at);
    if (visitsWithoutDate.length > 0 || oldVisitsWithoutDate.length > 0) {
      $("#errorDate").show();
      $('.alert-danger').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      });
      setTimeout(()=>{
        $('.alert-danger').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        });
        $("#errorDate").hide();
      }, 5000);
      return;
    }
    const btn = document.getElementById('plannedButton') as HTMLButtonElement;
    if (btn) {
      btn.disabled = true;
    }
    var formvalues = this.newActionForm.value;
    this.loadingPlanifyVisits = true;
    // if(this.newActionForm.valid){
          var newVisit = {
            created_visit : this.finalOldVisitToPlanify,
            new_visits : this.finalVisitsToAffect
          };          
          this.dashboardServiceservice.newVisitRequest = newVisit;
          this.dashboardServiceservice.getPlaned();
          this.newVisitRequest=this.dashboardServiceservice.planedSubject.subscribe(
            ( data: any ) => {
              if (btn) {
                btn.disabled = false;
              }
              if(data.code =="82bdf446339f91e11b62cd9b6839a9a1"){
                this.newActionForm.reset();
                $("#successSave").show();
                $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                  // $(this).removeClass();
                });
                setTimeout(()=>{
                  $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                    // $(this).removeClass();
                  });
                  $("#successSave").hide();
                }, 5000);
                this.visitsaffected=[];
                this.newActionForm.controls['sector_uuid'].setValue("", {onlySelf: true});
                this.newActionForm.controls['customer_uuid'].setValue("", {onlySelf: true});
                this.newActionForm.controls['city_uuid'].setValue("", {onlySelf: true});
                this.address = "- - -";  
                this.finalOldVisitToPlanify=[];
                this.finalVisitsToAffect=[];   
                // this.getIndicatorsClassesCustomers();     
                this.getClassesIndicatorsOfCommercialCustomers();  
              }else {
                $("#error").show();
                $('.alert-danger').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                  // $(this).removeClass();
                });
                setTimeout(()=>{
                  $('.alert-danger').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                    // $(this).removeClass();
                  });
                  $("#error").hide();
                }, 5000);
              }
              this.loadingPlanifyVisits = false;
              // this.newVisitForm.reset();
            },
          )
    // }
    $("html, body").animate({ scrollTop: 0 }, 500);
    
  }

  getAllCustomizedActions(){
    this.visitService.getAllCustomizedActions();
    this.visitService.customActionsSubject.subscribe(
      ( data: any ) => {
        if(data.code=="fc2057117571f77a7b4fdde71772ebcd"){
          this.customizedActions = data.actions;
          this.customizedActions = this.customizedActions.sort((a:any, b:any) => a.action_label.toLowerCase() > b.action_label.toLowerCase() ? 1 : -1);
          this.customizedActions = this.customizedActions.filter((v,i,a)=>a.findIndex(el=>(el.action_label===v.action_label))===i);
        }
      },
    )  
  }

  public loadScript(scripts:string) {
    let node = document.createElement("script");
    node.src = scripts;
    node.type = "text/javascript";
    node.async = true;
    node.charset = "utf-8";
    document.getElementsByTagName("head")[0].appendChild(node);
  }

  public loadCss(css:string) {
    let node = document.createElement("link");
    node.href = css;
    node.rel = "stylesheet";
    node.type = "text/css";
    node.media="all";
    document.getElementsByTagName("head")[0].appendChild(node);
  }

  classesIndicators!:any[];
  getIndicatorsClassesCustomers(){
    this.customersService.getIndicatorsClassesCustomers();
    this.customersService.customClassesIndicatorSubject.subscribe(
      ( data: any ) => {   
        if(data.code=="0ef2434c1eb1e67d8135a655882a9628"){
          this.classesIndicators = data.classes;
        }
      },
    )  
  }

  allClassesLoading:boolean=false;
  allClassesCustomers:any[]=[];
  finalListCustomers:any[]=[];
  lenghtClassA:number=0;
  lenghtClassB:number=0;
  lenghtClassC:number=0;
  lenghtClassD:number=0;
  async getClassesIndicatorsOfCommercialCustomers(){
    this.allClassesLoading=true;
    this.classesSubscription = this.customersService.getClassesIndicatorsOfCommercialCustomers().subscribe(
      async ( data: ServiceResponse ) => {   
        if(data.code=="1678347b5188d971b5f92362d1142daf"){
          this.classesIndicators = data.classes;
          // Extraire customerUuid et caTarget de tous les clients
          const customersWithTarget = this.classesIndicators
            .reduce((acc: any[], classe) => {
              if (classe.cutsomers && classe.cutsomers.length > 0) {
                const mapped = classe.cutsomers.map((customer: any) => ({
                  customerUuid: customer.customer,
                  caTarget: customer.caTarget
                }));
                return acc.concat(mapped);
              }
              return acc;
            }, []);
          this.processCustomersAfterRevenueUpdate();
          await this.refreshCustomersPrioritizationWithCa(customersWithTarget,"connected");
          this.allClassesCustomers=[]

          this.processCustomersAfterRevenueUpdate();
        }
        this.allClassesLoading=false;
      },
      (err:any) => {
        this.allClassesLoading=false;
        console.log(err);
        
      }
    )  
  }
  // ADAPTATION DE LA LISTE FINALE 
  processCustomersAfterRevenueUpdate() {
    this.allClassesCustomers = [];
    
    // Map de priorité des classes
    const classPriority: { [key: string]: number } = {
      'Classe A': 1,
      'Classe B': 2,
      'Classe C': 3,
      'Classe D': 4
    };
    
    for (let classe of this.classesIndicators) {
      if (classe?.cutsomers != null && classe?.cutsomers.length > 0) {
        for (let customer of classe?.cutsomers) {
          if (customer.affectedToMe || customer.affectedToMe == null) {
            customer.classe = classe.classe;
            customer.classPriority = classPriority[classe.classe] ?? 5;
            // Calculer le order basé sur les visites
            if (customer.countPeerMonth == 0) {
              if (customer.countPeerYear == 0) {
                customer.order = 0;
              } else if (customer.countPeerYear > 0 && customer.countPeerYear < customer.correctCountPeerYear) {
                customer.order = 1;
              } else if (!(customer.correctCountPeerYear > customer.countPeerYear)) {
                customer.order = 2;
              }
            } else if (customer.countPeerMonth > 0 && customer.countPeerMonth < customer.correctCountPeerMonth) {
              if (customer.countPeerYear == 0) {
                customer.order = 3;
              } else if (customer.countPeerYear > 0 && customer.countPeerYear < customer.correctCountPeerYear) {
                customer.order = 4;
              } else if (!(customer.correctCountPeerYear > customer.countPeerYear)) {
                customer.order = 5;
              }
            } else if (!(customer.countPeerMonth < customer.correctCountPeerMonth)) {
              if (customer.countPeerYear == 0) {
                customer.order = 6;
              } else if (customer.countPeerYear > 0 && customer.countPeerYear < customer.correctCountPeerYear) {
                customer.order = 7;
              } else if (!(customer.correctCountPeerYear > customer.countPeerYear)) {
                customer.order = 8;
              }
            } else {
              customer.order = 9;
            }
            
            this.allClassesCustomers.push(customer);
          }
        }
      }
    }
    
    // TRI PRINCIPAL: Classe > CA Objectif défini > CA Réalisé > CA à récupérer > Visites
    this.allClassesCustomers.sort((a: any, b: any) => {
      // 1. Par classe
      const classCompare = (a.classPriority ?? 5) - (b.classPriority ?? 5);
      if (classCompare !== 0) return classCompare;

      // 2. Clients AVEC CA Objectif avant SANS CA Objectif
      const hasTargetA = (a.caTarget ?? 0) > 0 ? 0 : 1;
      const hasTargetB = (b.caTarget ?? 0) > 0 ? 0 : 1;
      if (hasTargetA !== hasTargetB) return hasTargetA - hasTargetB;

      // 3. Clients avec CA encore à récupérer (caToGet > 0) avant ceux qui ont atteint leur objectif
      const hasCAToGetA = (a.caToGet ?? 0) > 0 ? 0 : 1;
      const hasCAToGetB = (b.caToGet ?? 0) > 0 ? 0 : 1;
      if (hasCAToGetA !== hasCAToGetB) return hasCAToGetA - hasCAToGetB;

      // 4. countPeerMonth = 0 en priorité (au sein du même groupe)
      const notVisitedMonthA = a.countPeerMonth === 0 ? 0 : 1;
      const notVisitedMonthB = b.countPeerMonth === 0 ? 0 : 1;
      if (notVisitedMonthA !== notVisitedMonthB) return notVisitedMonthA - notVisitedMonthB;

      // 5. Par CA réalisé croissant (0 en priorité)
      const caRealizedA = a.caRealized ?? 0;
      const caRealizedB = b.caRealized ?? 0;
      if (caRealizedA !== caRealizedB) return caRealizedA - caRealizedB;

      // 6. Par CA à récupérer décroissant (plus grand caToGet = plus urgent)
      const caToGetA = a.caToGet ?? 0;
      const caToGetB = b.caToGet ?? 0;
      if (caToGetA !== caToGetB) return caToGetB - caToGetA; // ✅ décroissant

      // 7. Par order (visites)
      return (a.order ?? 9) - (b.order ?? 9);
    });

    // Simplement recalculer les index après le tri (sans déplacer)
    this.allClassesCustomers.forEach((customer: any, index: number) => {
      customer.index = (index + 1) + "/" + this.allClassesCustomers.length;
    });  
  }

  refreshCustomersPrioritizationWithCa(customers: { customerUuid: string; caTarget: number }[], commercial: any): Promise<void> {
    commercial = "connected";
    return new Promise((resolve, reject) => {
      this.customersService.getCustomersSuggestionsByRevenue(customers, commercial).subscribe(
        (response: any) => {
          this.classesIndicators = response.classes;

          this.allClassesCustomers = this.classesIndicators
            .reduce((acc: any[], classe: any) => {
              if (classe.cutsomers && classe.cutsomers.length > 0) {
                const customersWithClass = classe.cutsomers.map((customer: any) => ({
                  ...customer,
                  classe: classe.classe
                }));
                return acc.concat(customersWithClass);
              }
              return acc;
            }, []);

          resolve();
        },
        (error: any) => {
          console.error('Error:', error);
          reject(error);
        }
      );
    });
  }

  mergeClassesData(newClasses: any[]) {
    this.classesIndicators = this.classesIndicators.map(oldClasse => {
      const newClasse = newClasses.find(c => c.classe === oldClasse.classe);
      
      if (!newClasse || !oldClasse.cutsomers) {
        return oldClasse;
      }

      const newCustomersMap = new Map(
        (newClasse.cutsomers || []).map((c: any) => [c.customer, c])
      );

      const updatedCustomers = oldClasse.cutsomers.map((oldCustomer: any) => {
        const newCustomer: any = newCustomersMap.get(oldCustomer.customer);
        
        if (!newCustomer) {
          return oldCustomer;
        }

        // Fusionner uniquement les champs CA (sans écraser les autres)
        return {
          ...oldCustomer,
          caRealized: newCustomer.caRealized ?? oldCustomer.caRealized ?? 0,
          caToGet: newCustomer.caToGet ?? oldCustomer.caToGet ?? 0,
          caGap: newCustomer.caGap ?? oldCustomer.caGap ?? 0,
          achievementRate: newCustomer.achievementRate ?? oldCustomer.achievementRate ?? 0,
          caByLastCommercial: newCustomer.caByLastCommercial ?? oldCustomer.caByLastCommercial ?? 0,
          priorityScore: newCustomer.priorityScore ?? oldCustomer.priorityScore ?? 0,
          lastCommercialUuid: newCustomer.lastCommercialUuid ?? oldCustomer.lastCommercialUuid
        };
      });

      updatedCustomers.sort((a: any, b: any) => (b.priorityScore ?? 0) - (a.priorityScore ?? 0));

      return {
        ...oldClasse,
        cutsomers: updatedCustomers
      };
    });
  }

  getCustomersToVisit(){
    $('.icon_click_here').delay(300).fadeIn(2000);  
    setTimeout(()=>{
      $('.icon_click_here').delay(300).fadeOut(2000);
    }, 3000);
  }

  customersToVisit:any[]=[];
  selectedClassModal:any;
  selectCustomersToVisit(classe:any){
    this.customersToVisit = classe.cutsomers;    
    this.selectedClassModal = classe.classe;
    $('.icon_click_here').delay(300).fadeIn(2000);  
    setTimeout(()=>{
      $('.icon_click_here').delay(300).fadeOut(2000);
    }, 3000);
  }
  CustomersIndex:any[]=[];
  selectedIndex:string="";
  select(uuid:any,customer:any,index:number){
    var city=null;
      this.address = "- - -";
      var cities = [];
      
      if ((customer.affectedToMe || customer.affectedToMe==null) 
        && customer.countPeerMonth !=null && customer.countPeerMonth<=customer.correctCountPeerMonth) {
        var selectedelement = this.refClients.find(d => d.uuid== uuid);
        selectedelement.index = index;
        var indexOfAllSuggestions ="";        
        if(index != null){
          this.selectedIndex = index+1+"/"+this.allClassesCustomers.length;
          indexOfAllSuggestions ="";
        }
        this.newActionForm.controls['customer_uuid'].setValue(uuid);

        if (selectedelement.sector)
        this.newActionForm.controls['sector_uuid'].setValue(selectedelement.sector);
        
        this.ShowBlocNewVisit=true;  
        
        if (selectedelement?.cities.length>0) {
          for (const cityine of selectedelement.cities) {            
            city = {
              city:cityine.name,
              city_uuid:cityine.uuid,
              address:selectedelement?.address,
              customer:selectedelement?.uuid
            }
            cities.push(city);
            this.citiesClient = cities;            
          }
          $('#citiesSelect').addClass("clignote_selected_customer");
          setTimeout(()=>{
            $('#citiesSelect').removeClass("clignote_selected_customer");
          }, 3000);
        } else if(selectedelement?.sites?.length===1) {      
          city = {
            city:selectedelement.sites[0].city,
            uuid:selectedelement.sites[0].uuid,
            address:selectedelement.sites[0].address,
            customer:selectedelement.uuid
          }
          cities.push(city);
          this.newActionForm.controls['city_uuid'].setValue(selectedelement.cities[0].city_uuid);
          this.citiesClient = cities;
          $('#visitdate').addClass("clignote_selected_customer");
          setTimeout(()=>{
            $('#visitdate').removeClass("clignote_selected_customer");
          }, 3000);
        } else {          
          if(selectedelement?.city_uuid){
            city = {
              city:selectedelement.city,
              city_uuid:selectedelement.city_uuid,
              address:selectedelement.address,
              customer:selectedelement.uuid
            }
            cities.push(city);
          }
          
          this.citiesClient = cities;
        }
        if (cities.length>0) {
          $("#formNewVisit").show();
          $("#blocListCreatedVisits").hide();
          $("#citiesSelect").prop("disabled", false);
          (<any>$('#suggestions')).modal('hide');
        } else {
          $("#citiesSelect").prop("disabled", true);
        }        
      }
  }

  ShowBlocNewVisit:boolean=false;
  ShowFormNewVisits(){
    $("#formNewVisit").fadeIn();
    $("#blocListCreatedVisits").fadeOut();
    this.ShowBlocNewVisit = true;
  }

  CancelCreatedVisits() {
    this.getAffected(1);
    this.getAffected(4);
    this.getAffected(5);
    this.visitsaffected = [];
    this.finalOldVisitToPlanify = [];
    for(let toCancel of this.allClassesCustomers){
      $("#customer-sugg-"+this.allClassesCustomers.indexOf(toCancel)).prop("checked", false);
      $("#icon_seleced-"+this.allClassesCustomers.indexOf(toCancel)).css({"display":"none"});
    }
  }
  CancelForm(){
    this.newActionForm.reset();
    this.newActionForm.controls['sector_uuid'].setValue("", {onlySelf: true});
    this.newActionForm.controls['customer_uuid'].setValue("", {onlySelf: true});
    this.newActionForm.controls['city_uuid'].setValue("", {onlySelf: true});
    this.newActionForm.controls['topic_uuid'].setValue([], {onlySelf: true});
    this.resetSelectedTopics(); // MF-1881 — vide aussi les badges
    this.address = "- - -";
    this.actionsSelected = [];
    $("#formNewVisit").hide();
    $("#blocListCreatedVisits").show();
    this.getAllCustomers();
    this.ShowBlocNewVisit = false; 
    this.searchCustomerForm.reset();
    this.searchCustomerForm.controls.sector.setValue("", {onlySelf: true});
    this.searchCustomerForm.controls.city.setValue("", {onlySelf: true});
    this.searchedCustomers = []
    $("#referential-table").hide();   
  }

  deleteVisitFromListPlan(uuidVisit:any) {    
    let item1 = this.visitsaffected.find(i => i.visit === uuidVisit);
    var index = this.visitsaffected.indexOf(item1);
    if (index !== -1) {
      let visitToDelete = this.finalVisitsToAffect.find(i => i.visit === uuidVisit);
      var indexVisit = this.visitsaffected.indexOf(visitToDelete);
      this.visitsaffected.splice(index, 1);
      if (indexVisit !== -1) {
        this.finalVisitsToAffect.splice(indexVisit, 1);
      }
    }
  }

  deleteOldVisitFromListPlan(uuidVisit:any, status:number) {
    let item1 = this.finalOldVisitToPlanify.find(i => i.visit === uuidVisit);
    var index = this.finalOldVisitToPlanify.indexOf(item1);
    if (index !== -1) {
      this.finalOldVisitToPlanify.splice(index, 1);
    }    

    this.getAffected(status);
  }

  affectDateToOldVisit(event:any,uuid:any) {
    var newDate = event.target.value;
    let item1 = this.finalOldVisitToPlanify.find(i => i.visit === uuid);
    item1.planned_at = newDate;
  }
  selectedGoalVisit:any=null;
  writeDescription(event:any,uuid:any){
    var description = event.target.value;
    let item1 = this.finalOldVisitToPlanify.find(i => i.visit === uuid);
    item1.description = description;
  }
  // ------------------------------------------------------------------------------------------
  // MF-1881 — sujets de la liste « à replanifier », un jeu de badges par ligne.
  //
  // Chaque ligne porte son propre tableau `topicsSelected` ({ uuid, topic }), et `topics` qui
  // ne contient que les identifiants, c'est-à-dire ce que le back attend dans la requête.
  // ------------------------------------------------------------------------------------------

  /** Les sujets choisis sur cette ligne, pour l'affichage des badges. */
  rowTopics(visit: any): any[] {
    if (!visit.topicsSelected) { visit.topicsSelected = []; }
    return visit.topicsSelected;
  }

  /**
   * MF-1881 — reconstruit les badges d'une ligne à partir des sujets déjà portés par la visite.
   *
   * `topic_uuids` et `topic` arrivent du back dans le même ordre : identifiants d'un côté,
   * libellés de l'autre. Le libellé est repris tel quel plutôt que relu dans le référentiel,
   * pour qu'un sujet désactivé depuis reste affiché au lieu de disparaître en silence.
   *
   * `visit.topics` est aussi renseigné : c'est ce que la requête enverra au back, et sans cela
   * replanifier une visite sans toucher aux sujets les effacerait.
   */
  private prefillRowTopics(visit: any): void {
    const uuids: string[] = Array.isArray(visit?.topic_uuids) ? visit.topic_uuids : [];
    const labels: string[] = Array.isArray(visit?.topic) ? visit.topic : [];

    visit.topicsSelected = uuids
        .filter((uuid: string) => !!uuid)
        .map((uuid: string, i: number) => {
          const fallback = (this.topics || []).find((t: any) => t.uuid === uuid);
          return { uuid: uuid, topic: labels[i] ?? (fallback ? fallback.topic : uuid) };
        });

    visit.topics = visit.topicsSelected.map((t: any) => t.uuid);
  }

  /** Vrai quand la ligne a atteint la borne : sa liste déroulante se grise. */
  rowTopicsLimitReached(visit: any): boolean {
    return this.rowTopics(visit).length >= MAX_TOPICS;
  }

  /** MF-1881 — ajout d'un sujet sur une ligne « à replanifier ». */
  selectTopic(event:any,uuid:any){
    const select = event.target as HTMLSelectElement;
    const topicUuid = select.value;
    if (!topicUuid) { return; }

    const item1 = this.finalOldVisitToPlanify.find(i => i.visit === uuid);
    if (!item1) { select.value = ""; return; }

    const selected = this.rowTopics(item1);
    if (selected.length >= MAX_TOPICS) { select.value = ""; return; }

    if (selected.findIndex((t: any) => t.uuid === topicUuid) < 0) {
      const ref = (this.topics || []).find((t: any) => t.uuid === topicUuid);
      if (ref) {
        selected.push({ uuid: ref.uuid, topic: ref.topic });
        item1.topics = selected.map((t: any) => t.uuid);
      }
    }
    select.value = "";
  }

  /** MF-1881 — retrait d'un sujet d'une ligne « à replanifier ». */
  removeRowTopic(visit: any, topic: any): void {
    const selected = this.rowTopics(visit);
    const index = selected.findIndex((t: any) => t.uuid === topic.uuid);
    if (index >= 0) {
      selected.splice(index, 1);
      visit.topics = selected.map((t: any) => t.uuid);
    }
  }

  getCities() {
    this.newCustomerForm.controls.city.setValue("");
    this.customersService.getRefCities();
    this.customersService.refCitiesSubject.subscribe(
      ( data: any ) => {
        if(data.code=="9d0907561104ccc6b9d188f036bd358c"){
          this.refCities = data.cities;
        }
      },
    )  
  }

  addNewCustomer() {
    var valuesNewCustomerForm = this.newCustomerForm.value;
    this.loadingAddingCustomer = true;
    if (this.newCustomerForm.valid) {
          this.newCustomerRequest = {
            social_reason:valuesNewCustomerForm.social,
            customer_sector:valuesNewCustomerForm.sector,
            represented_by:valuesNewCustomerForm.agent,
            customer_email:valuesNewCustomerForm.email,
            customer_cities:this.cities,
            customer_zip:valuesNewCustomerForm.zip,
            customer_address:valuesNewCustomerForm.address,
            customer_phone: valuesNewCustomerForm.phone,
            customer_skype: valuesNewCustomerForm.skype,
            customer_class: valuesNewCustomerForm.class,
            customer_sites:this.sites,
            customer_services: this.services
          };
          if (this.selectedLogo) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const logoDataUrl = e.target?.result as string;
                this.newCustomerRequest.customer_logo = logoDataUrl.split(',')[1];
                this.continueWithCustomerCreation();
            };
            reader.readAsDataURL(this.selectedLogo);
        } else {
            this.continueWithCustomerCreation();
        }
    }
  }

  continueWithCustomerCreation() {
    this.customersService.newCustomerRequest = this.newCustomerRequest;
    this.customersService.newCustomer();
    this.newCustomerRequest=this.customersService.newCustomerSubject.subscribe(
      ( data: any ) => {
        $("html, body").animate({ scrollTop: 0 }, 500);
        if(data.code=="321b6e3b3785131f5cee153737dba9a2"){
          this.loadingAddingCustomer = false;
          this.newCustomerForm.reset();
          const imageDiv = document.getElementById('imageDiv');
          if(imageDiv) imageDiv.innerHTML = '';
          this.cities =[];
          this.sites =[];
          this.services =[];
          let cust = data.customer

          // MF-1847_1 : on reconstruit villes/sites à partir de la réponse serveur
          // (customer_cities[].sites, désormais renvoyée par le backend), au lieu des
          // champs customer_city/city qui n'existent plus sur l'enveloppe et donnaient
          // toujours des sites vides pour un client créé depuis cette popin.
          let serverCities = cust.customer_cities || [];
          let cities = serverCities.map((c:any) => ({ name: c.name, uuid: c.uuid }));
          let sites = serverCities.flatMap((c:any) => (c.sites || []).map((s:any) => ({
            uuid: s.siteUuid,
            site_name: s.siteName,
            address: s.siteAddress,
            city_uuid: c.uuid,
          })));

          var customer = {
            rs_customer:cust.customer_rs,
            uuid:cust.customer,
            address:cust.customer_address,
            cities:cities,
            sites:sites,
            sector:cust.sector
          }
          this.refClients.push(customer);

          this.newActionForm.get('customer_uuid')?.setValue(customer.uuid);
          this.newActionForm.controls['sector_uuid'].setValue(customer.sector);

          this.citiesClient = cities.map((city:any) => {
            return { city_uuid: city.uuid, city: city.name, customer: customer.uuid };
          });

          this.sitesOfCity = [];
          this.newActionForm.controls['site_uuid'].setValue("", {onlySelf: true});
          this.address = '- - -';
          if (this.citiesClient.length === 1) {
            this.newActionForm.get('city_uuid')?.setValue(this.citiesClient[0].city_uuid);
            // setValue() ne déclenche pas le "change" jQuery de #citiesSelect : on appelle
            // nous-même updateSitesForCity pour peupler le champ Site.
            this.updateSitesForCity(customer, this.citiesClient[0].city_uuid);
          }else if (this.citiesClient.length > 1){
            this.newActionForm.get('city_uuid')?.setValue('');
          }
          $("#citiesSelect").prop("disabled", false);

          this.customer = customer.uuid;
          this.newCustomerForm.controls['sector'].setValue("", {onlySelf: true});
          this.newCustomerForm.controls['city'].setValue("", {onlySelf: true});
          $("#customer_added").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#customer_added").hide();
          }, 8000);
          // this.allCustomers.push(data.customer);
        } else if (data.code=="06c61e9f990cce9353c3064f99f6ec42"){
          this.addError ="Client existe dèja"; 
          this.loadingAddingCustomer = false;
          $("#customer_not_added").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#customer_not_added").hide();
          }, 8000)
        } else {
          this.addError ="Client non ajouté"; 

          this.loadingAddingCustomer = false;
          $("#customer_not_added").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#customer_not_added").hide();
          }, 8000);
        }
      },
    )
  }

  serchCustomer(){
    this.searchLoading = true;
    let searchValue = this.searchCustomerForm.value;

    let customerSearched = new Customer();
    customerSearched.social_reason = searchValue.social;
    customerSearched.customer_sector = searchValue.sector;
    customerSearched.customer_city = searchValue.city;
    customerSearched.customer_class = searchValue.classe;
    
    this.searchSubscription = this.customersService.searchCustomer(customerSearched).subscribe(
      (resp:ServiceResponse) => {
        
        if(resp.code == "41ada51bff1a929b7584e3e9e7f77a53"){
          this.searchLoading = false;
          resp.customers.forEach((customer:any) => {
            this.msSector.getSector(this.token, customer.sector).subscribe(
              (sectorLabel: any) => {
                customer.customer_sector = sectorLabel.label;
              },
              (error) => {
                console.log(error);
              }
            );
          });
          this.searchedCustomers = resp.customers;
        }
        this.searchLoading = false;
      },
      (err:Error) => {
        console.log(err);
        this.searchLoading = false;
      }
    );
  }

  selectCustomer(cust:any){ 
    var cities: any[] = [];
    for (const cityine of cust.customer_cities) {            
      var cityfromref = {
        city:cityine.name,
        city_uuid:cityine.uuid,
        address:cust?.customer_address,
        customer:cust?.customer
      }
      cities.push(cityfromref);
      this.citiesClient = cities;            
    }
    var customer = {
      rs_customer:cust.customer_rs,
      city_uuid:cust.customer_city,
      uuid:cust.customer,
      address:cust.customer_address,
      sites:cust.sites,
      sector:cust.sector
    }
    this.refClients.push(customer);
    this.newActionForm.get('customer_uuid')?.setValue(customer.uuid);
    this.newActionForm.controls['sector_uuid'].setValue(customer.sector);
    if(cities.length==1) {
      this.newActionForm.controls['city_uuid'].setValue(cities[0].city_uuid);
      this.address = customer !=undefined && customer.sites?.length >= 1 ? customer.sites.find((s:any) => s.city_uuid == cities[0].city_uuid)?.address:'- - -';
    }
    $("#citiesSelect").prop("disabled", false);
    this.address = cust?.customer_address;
    this.customer = cust?.customer;
  }
  getCityNames(customerCities: any) {
    return customerCities.map((city: any) => city.name).join("\n");
  }
  ngOnDestroy() {
    this.searchSubscription?.unsubscribe();
    this.commercialCustomersSubscription?.unsubscribe();
    this.classesSubscription?.unsubscribe();
  }
  selectedSuggestions:any[]=[];
  selectedIndexes:any[]=[];
  selectCard(index:any,customer:any){
    if (jQuery("#icon_seleced-"+index).css('display') == 'inline' || this.selectedSuggestions?.indexOf(this.allClassesCustomers[index])!= -1){
      $("#icon_seleced-"+index).css({"display":"none"});
      var elementToDelete = this.allClassesCustomers[index];
      this.selectedSuggestions.splice(this.selectedSuggestions.indexOf(elementToDelete), 1);
    }else {
      if(this.selectedSuggestions?.indexOf(customer)== -1){
        $("#icon_seleced-"+index).css({"display":"inline"});
        $("#icon_seleced-"+index).css({"right":"0"});
        var elementToAdd = this.allClassesCustomers[index];
        this.selectedSuggestions.push(elementToAdd);
      }
    }
    if(this.selectedSuggestions.length>0){
      $("#planifyAllSelect").css({"display":"block"});
      this.selectedIndexes.push(index);
    }else {
      $("#planifyAllSelect").css({"display":"none"});
      this.selectedIndexes.splice(this.selectedIndexes.indexOf(index),1);
    }
  }
  finalisePlanifications(){
    (<any>$('#allSuggestions')).modal('hide');
    $("#planifyAllSelect").css({"display":"none"});    
    this.select(this.selectedSuggestions[0].customer,this.selectedSuggestions[0],this.selectedIndexes[0]);
  }
  closeSuggestions() {
    $("#planifyAllSelect").css({"display":"none"});
  }
  verifylenght(event: any){
    if(event.target.value.length>0){
      var len:any = event.target.value.length-1;
      let toshowNumber:any = "<span>"+len+"/255</span>";
      if(len<=255){
        $("#description").html("<span style='color:green'"+toshowNumber+"</span>");
      }else {
        $("#description").html("<span style='color:red'"+toshowNumber+"</span>");
      }
    }else {
      $("#description").html("<span style='color:green'><span>0/255</span></span>");
    }
  }
}